<template>
  <div ref="ABC" class="reminderadHoc emp-audit-wrap">
    <div class="pa-2 d-flex flex-row flex-wrap">
      <v-col cols="8" class="px-0">
          <h2>Share campaign</h2>
          <small style="font-size:100%;">You can share this campaign with your admin.</small>
      </v-col>
      <v-col cols="4">
        <v-btn
        color="primary"
        v-bind="attrs" v-on="on"
        dark
        @click="openShare()"
        slot="activator"
        class="text-none float-right"
        >
        <v-icon style="font-size:12px;" small class="mr-2">las la-share</v-icon> Share campaign
        </v-btn>
      </v-col>
      <v-card v-if="shareData.length == 0" class="elevation-0 text-center w-100" min-height="300" style="border:1px solid #050550;">
          <v-card-title adhoc-title class="justify-center pb-0">
              <div class="d-flex flex-row flex-wrap">
                  <v-flex xs12>
                      <img :src="getImgUrl('amara_avatar')" class="blank-avatar-small" alt="">
                      <!-- <h2 class="headline">Welcome {{user.company_name}}!</h2> -->
                      <p class="subheading grey--text mb-3">You haven’t share this campaign yet.</p>
                          <v-btn
                            v-bind="attrs" v-on="on"
                            color="primary"
                            dark
                            @click="openShare()"
                            slot="activator"
                            class="text-none"
                          >
                          <v-icon style="font-size:12px;" small class="mr-2">las la-share</v-icon> Share campaign
                          </v-btn>
                  </v-flex>
              </div>
          </v-card-title>
          <v-card-actions class="justify-center">
          </v-card-actions>
      </v-card>
      <!-- <v-layout class="pt-5" style="padding:10px 20px">
          <v-flex xs2>
            S.no.
          </v-flex>
          <v-flex xs2>
              Title
          </v-flex>
          <v-flex xs2>
              Audience Type
          </v-flex>
          <v-flex xs2>
              Schedule
          </v-flex>
          <v-flex xs2>
              Distribution Channel
          </v-flex>
          <v-flex xs2>
              Actions
          </v-flex>
      </v-layout> -->
      <!-- <v-layout v-if="reminderData.length > 0" v-for="(reminder, r) in reminderData" :key="r" class="campaign-row" -->
      <div class="list-wrap w-100" style="overflow-x:hidden;" v-if="shareData.length > 0">
      <div class="row mx-1">
        <div class="col-1 text-left" style="max-width:5%;">
          SN
        </div>
        <div class=" text-left col-4">
          Shared with
        </div>
        <div class=" text-left col-4">
          Shared by
        </div>
        <div class=" text-left col-2">
          Date
        </div>
        <div class=" text-left col-1">
          Actions
        </div>
      </div>
      <div
        class="row elevation-0 px-0 mx-1 my-2 bg-white campaign-row" style="border-radius: 6px;"
        v-for="(i,index) in shareData"
        :key="index"
      >
        <div class=" text-left col-1" style="max-width:5%;">
          <div>
            <div>{{index + 1}}</div>
          </div>
        </div>
        <div class=" text-left col-4">
          <div style="overflow:hidden">
            <div class="a-name">{{i.shared_with.display_name}}</div>
            <div>{{i.shared_with.email}}</div>
          </div>
        </div>
        <div class=" text-left col-4">
          <div style="overflow:hidden">
            <div class="a-name">{{i.created_by.display_name}}</div>
            <div>{{i.created_by.email}}</div>
          </div>
        </div>
        <div class=" text-left col-2">
          {{dayjs(i.created_at).format('DD-MM-YYYY-HH:mm')}}
        </div>
        <div class=" text-left col-1">
          <v-btn text icon @click="deleteShare(i.id)">Revoke</v-btn>
        </div>
      </div>
      <!-- <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
        <span slot='no-more'>{{' '}}</span>
        <span slot='no-results'>{{' '}}</span>
      </infinite-loading> -->
    </div>
    </div>
    <share-to
      :shareToList="shareToList"
      :campaignDetails="campaignDetails"
      @assignEmployee="assignEmployee"
      ref="AssignedTo"
    ></share-to>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
// import { ContentLoader } from 'vue-content-loader';
import VuePellEditor from 'vue-pell-editor';
import axios from 'axios';
import dayjs from 'dayjs';
// import InfiniteLoading from 'vue-infinite-loading';
import relativeTime from 'dayjs/plugin/relativeTime';
import ShareTo from './dialog/share-to';
// import RecipientTranscript from '@/components/elements/RecipientTranscript';
// import {
//   VCheckbox,
//   VAvatar,
//   VTooltip,
//   VAlert,
//   VBtn,
//   VTextarea,
//   VProgressLinear,
//   VChip,
//   VMenu,

// } from 'vuetify';
Vue.use(VuePellEditor);
dayjs.extend(relativeTime);

export default {
  name: 'EmployeesList',
  props: {
    campaignDetails: {
      required: true,
      type: Array
    }
  },
  components: {
    ShareTo
    // InfiniteLoading
    // ContentLoader,
    // VCheckbox,
    // VAvatar,
    // VTooltip,
    // VAlert,
    // VTextarea,
    // VMenu,
    // VBtn,
    // dayjs,
    // VChip,
    // RecipientTranscript,
    // VProgressLinear,
  },
  data () {
    return {
      shareData: [],
      page: 1,
      nowDate: new Date().toISOString().slice(0, 10),
      emailData: '',
      selected: '',
      searchAssignedToUser: '',
      filteredUser: [],
      Sender: null,
      currentTime: '',
      shareToList: [],
      previewData: false,
      previewDialogEmail: false,
      editView: false,
      reminderId: '',
      date_time: [],
      model: false,
      model2: false,
      dialog: false,
      previewDialog: false,
      testCampaigns: false,
      testEmailData: false,
      testSmsData: false,
      subjectEmail: 'Reminder: Tell us how you feel',
      bodySMS: 'Hi You would have received a request from Amara to participate in a campaign, this campaign has been designed to gauge your satisfaction level at work. All you have to do is chat with Amara and she will take care of the rest. A gentle reminder to complete the chat by sparing 5 minutes, remember when we know how you feel, we can help you better.',
      bodyEmail: '<div>A big hello!</div><div><br></div><div>Hope you are doing great!</div><div><br></div><div><br></div><div>I am Amara, your virtual friend at work. Looks like you missed my last mail, so I am writing to you again.</div><div><br></div><div>I would like to chat with you to know your thoughts and feelings as it is essential&nbsp;to know more about you&nbsp;and your experiences at work. All you have to do is just spare five minutes and converse with me, I promise to make this very quick. Also, there are interesting methods to respond--choose an emoji, MCQs, and more. This will be fun and also help us to improve and enhance the workplace culture as per your wishes.&nbsp;</div>',
      reminder: {
        chooseRadio: true,
        chooseRadio1: false
      },
      reminderData: [],
      mediumSelected: '',
      stageId: '',
      reminderActions: [{
        title: 'Edit',
        icon: 'fas fa-chart-bar',
        dialog: 'view',
        action: this.edit
      }, {
        title: 'Preview',
        icon: 'fas fa-play',
        dialog: 'edit',
        action: this.preview
      }, {
        title: 'Test',
        icon: 'fas fa-play',
        dialog: 'edit',
        action: this.testCampaign
      }, {
        title: 'Delete',
        icon: 'fas fa-trash',
        dialog: 'deleteStage',
        action: this.deleteReminder
      }],
      reminder_items: [{
        title: 'Automate reminder',
        value: 'automated'
      }, {
        title: 'One-off reminder',
        value: 'onetime'
      }],
      audienceType: [{
        title: 'Non responder',
        value: 'no_response'
      }, {
        title: 'Partial responder',
        value: 'partial_response'
      }, {
        title: 'Both',
        value: 'both'
      }],
      triggerDuration: [{
        title: 'After 1 day',
        value: 1
      }, {
        title: 'After 2 day',
        value: 2
      }, {
        title: 'After 3 day',
        value: 3
      }, {
        title: 'After 4 day',
        value: 4
      }, {
        title: 'After 5 day',
        value: 5
      }, {
        title: 'After 6 day',
        value: 6
      }, {
        title: 'After 7 day',
        value: 7
      }],
      acknowledgment_items: [{
        title: 'Automated thank you email',
        value: 'automated'
      }, {
        title: 'One-off thank you email',
        value: 'onetime'
      }]
    };
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    downloadFile (url) {
      window.open(url);
    },
    infiniteHandler ($state) {
      var that = this;
      if (that.campaignDetails.stage_id) {
        axios.get(`${process.env.VUE_APP_ADHOC_API_URL}stage/${that.campaignDetails.stage_id}/share_settings/`, {
        }).then((response) => {
          if (response.data) {
            this.shareData = response.data;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to get details, Please try again later!'
            });
          }
        });
      }
    },
    deleteShare (id) {
      var that = this;
      if (that.campaignDetails.stage_id) {
        axios.delete(`${process.env.VUE_APP_ADHOC_API_URL}stage/${that.campaignDetails.stage_id}/share_settings/${id}`, {
        }).then((response) => {
          if (response) {
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Deleted successfully!'
            });
            this.infiniteHandler();
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to delete, Please try again later!'
            });
          }
        });
      }
    },
    getAdminUsers () {
      const tempList = [];
      axios.get(`${process.env.VUE_APP_ADHOC_API_URL}user/admins_list`).then((response) => {
        if (response && response.data.data && response.data.data.length > 0) {
          this.$lodash.each(response.data.data, (val) => {
            const t = {};
            t.text = val.display_name;
            t.id = val.id;
            t.email = val.email;
            tempList.push(t);
          });
        } else {
          const noData = {};
          noData.title = 'No data available';
          noData.id = null;
          tempList.push(noData);
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get admins list, Please try again later!'
          });
        }
      });
      this.shareToList = []; // for reset the existing data
      this.shareToList = tempList;
      this.filteredUser = tempList;
    },
    back () {
      this.mediumSelected = '';
      if (this.testEmailData) {
        this.testEmailData = false;
        this.mediumSelected = 'email';
      }
      if (this.testSmsData) {
        this.testSmsData = false;
        this.mediumSelected = 'sms';
      }
    },

    getColor1 (channel) {
      let color = '#432d6f';
      if (channel === 'email') {
        color = '#432d6f';
      } else if (channel === 'sms') {
        color = '#8a3984';
      }
      return color;
    },
    testEmail () {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.reminder.channel === 'email') {
            this.testEmailData = true;
          }
          if (this.reminder.channel === 'sms') {
            this.testSmsData = true;
          }
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    testCampaign (data) {
      this.testCampaigns = true;
      this.edit(data);
    },
    sendTest () {
      if (this.$route.params && this.$route.params.stageId) {
        this.stageId = this.$route.params.stageId;
      }
      this.Sender = this.user.company_name.split(' ');
      const temp = {
        channel: this.reminder.channel,
        subject: this.reminder.channel === 'email' ? this.subjectEmail : undefined,
        body: this.reminder.channel === 'email' ? this.bodyEmail : this.bodySMS,
        email: this.reminder.test_emailId,
        phone: this.reminder.test_mobile,
        first_name: this.reminder.test_first_name,
        last_name: this.reminder.test_last_name,
        sender: `${this.user.company_name} <${this.Sender[0]}@amara.ai>`
      };
      this.$validator.validateAll().then((res) => {
        if (res) {
          axios.post(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.stageId}/reminders/test/`, temp)
            .then((resp) => {
              if (resp.data) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'success',
                  show: true,
                  text: 'Test reminder has been successfully sent!'
                });
                this.testEmailData = false;
                this.testSmsData = false;
                if (this.testCampaigns) {
                  this.reminder = {};
                  this.closeModal();
                }
              }
            }).catch((err) => {
              if (err.response.status === 429) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to send test reminder, Please try again later!'
                });
              }
            });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    save () {
      if (this.$route.params && this.$route.params.stageId) {
        this.stageId = this.$route.params.stageId;
      }
      if (this.reminder.recipient_filter_type === 'no_response') {
        this.reminder.recipient_filter = { status__in: 'initiated' };
      }
      if (this.reminder.recipient_filter_type === 'partial_response') {
        this.reminder.recipient_filter = { status__in: 'inProgress' };
      }
      if (this.reminder.recipient_filter_type === 'both') {
        this.reminder.recipient_filter = { status__in: 'initiated, inProgress' };
      }
      const temp = {
        stage: this.stageId,
        channel: this.reminder.channel,
        subject: this.reminder.channel === 'email' ? this.subjectEmail : undefined,
        body: this.reminder.channel === 'email' ? this.bodyEmail : this.bodySMS,
        title: `Reminder ${this.reminderData.length + 1}`,
        type: this.reminder.type,
        trigger_time_duration: this.reminder.trigger_time_duration,
        trigger_time_unit: 'days',
        trigger_date_time: this.reminder.type === 'onetime' ? `${this.reminder.date}T${this.reminder.time}` : undefined,
        recipient_filter_type: this.reminder.recipient_filter_type,
        recipient_filter: this.reminder.recipient_filter,
        created_by: !this.editView ? this.user.email : undefined,
        last_update_by: this.user.email
      };
      this.$validator.validateAll().then((res) => {
        if (res) {
          axios.post(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.stageId}/reminders/`, temp)
            .then((resp) => {
              if (resp.data) {
                this.reminder = {};
                this.mediumSelected = '';
                this.dialog = false;
                this.$store.dispatch('updateSnackbar', {
                  color: 'success',
                  show: true,
                  text: 'Reminder created successfully!'
                });
                this.getReminder();
              }
            }).catch((err) => {
              if (err.response.status === 429) {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: err.response.data.error
                });
              } else {
                this.$store.dispatch('updateSnackbar', {
                  color: 'error',
                  show: true,
                  text: 'Unable to create reminder, Please try again later!'
                });
              }
            });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Fill all the mandatory fields!'
          });
        }
      });
    },
    update () {
      if (this.$route.params && this.$route.params.stageId) {
        this.stageId = this.$route.params.stageId;
      }
      if (this.reminder.recipient_filter_type === 'no_response') {
        this.reminder.recipient_filter = { status__in: 'initiated' };
      }
      if (this.reminder.recipient_filter_type === 'partial_response') {
        this.reminder.recipient_filter = { status__in: 'inProgress' };
      }
      if (this.reminder.recipient_filter_type === 'both') {
        this.reminder.recipient_filter = { status__in: 'initiated, inProgress' };
      }

      const temp = {
        stage: this.stageId,
        channel: this.reminder.channel,
        subject: this.reminder.channel === 'email' ? this.subjectEmail : undefined,
        body: this.reminder.channel === 'email' ? this.bodyEmail : this.bodySMS,
        type: this.reminder.type,
        trigger_time_duration: this.reminder.type === 'automate' ? this.reminder.trigger_time_duration : undefined,
        trigger_time_unit: this.reminder.type === 'automate' ? 'days' : undefined,
        trigger_date_time: this.reminder.type === 'onetime' ? `${this.reminder.date}T${this.reminder.time}` : undefined,
        recipient_filter_type: this.reminder.recipient_filter_type,
        recipient_filter: this.reminder.recipient_filter,
        created_by: this.user.email,
        last_update_by: this.editView ? this.user.email : undefined
      };
      axios.patch(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.stageId}/reminders/${this.reminderId}/`, temp)
        .then((resp) => {
          if (resp.data) {
            this.reminder = {};
            this.mediumSelected = '';
            this.dialog = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Reminder updated successfully!'
            });
            this.editView = false;
            this.getReminder();
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to update reminder, Please try again later!'
            });
          }
        });
    },
    getReminder () {
      if (this.$route.params && this.$route.params.stageId) {
        this.stageId = this.$route.params.stageId;
      }
      axios.get(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.stageId}/reminders/`).then((response) => {
        if (response && response.data) {
          this.reminderData = response.data;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get template, Please try again later!'
          });
        }
      });
    },
    deleteReminder (data) {
      if (this.$route.params && this.$route.params.stageId) {
        this.stageId = this.$route.params.stageId;
      }
      axios.delete(`${process.env.VUE_APP_ADHOC_API_URL}stage/${this.stageId}/reminders/${data.id}`).then((response) => {
        if (response) {
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'successfully delete!'
          });
          this.getReminder();
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to delete reminder, Please try again later!'
          });
        }
      });
    },
    selectedMedium (medium) {
      this.subjectEmail = 'Reminder: Tell us how you feel';
      this.bodySMS = 'Hi You would have received a request from Amara to participate in a campaign, this campaign has been designed to gauge your satisfaction level at work. All you have to do is chat with Amara and she will take care of the rest. A gentle reminder to complete the chat by sparing 5 minutes, remember when we know how you feel, we can help you better.';
      this.bodyEmai = '<div>A big hello!</div><div><br></div><div>Hope you are doing great!</div><div><br></div><div><br></div><div>I am Amara, your virtual friend at work. Looks like you missed my last mail, so I am writing to you again.</div><div><br></div><div>I would like to chat with you to know your thoughts and feelings as it is essential&nbsp;to know more about you&nbsp;and your experiences at work. All you have to do is just spare five minutes and converse with me, I promise to make this very quick. Also, there are interesting methods to respond--choose an emoji, MCQs, and more. This will be fun and also help us to improve and enhance the workplace culture as per your wishes.&nbsp;</div>';
      if (medium === 'email') {
        this.reminder.chooseRadio = true;
        this.reminder.chooseRadio1 = true;
      }
      if (medium === 'sms') {
        this.reminder.chooseRadio = false;
        this.reminder.chooseRadio1 = true;
      }
      this.reminder.channel = medium;
      this.mediumSelected = medium;
      this.testEmailData = false;
      this.testSmsData = false;
    },
    openShare () {
      this.$refs.AssignedTo.open = true;
      this.$refs.AssignedTo.infiniteHandler();
      // console.log(this.$refs.AssignedTo);
    },
    getImgUrl (pet) {
      const images = require.context('@/assets/', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    closeModal () {
      this.mediumSelected = '';
      this.subjectEmail = 'Reminder: Tell us how you feel';
      this.bodySMS = 'Hi You would have received a request from Amara to participate in a campaign, this campaign has been designed to gauge your satisfaction level at work. All you have to do is chat with Amara and she will take care of the rest. A gentle reminder to complete the chat by sparing 5 minutes, remember when we know how you feel, we can help you better.';
      this.bodyEmai = '<div>A big hello!</div><div><br></div><div>Hope you are doing great!</div><div><br></div><div><br></div><div>I am Amara, your virtual friend at work. Looks like you missed my last mail, so I am writing to you again.</div><div><br></div><div>I would like to chat with you to know your thoughts and feelings as it is essential&nbsp;to know more about you&nbsp;and your experiences at work. All you have to do is just spare five minutes and converse with me, I promise to make this very quick. Also, there are interesting methods to respond--choose an emoji, MCQs, and more. This will be fun and also help us to improve and enhance the workplace culture as per your wishes.&nbsp;</div>';

      this.previewData = false;
      this.testEmailData = false;
      this.testSmsData = false;
      this.testCampaigns = false;
      this.reminder = {};
      this.editView = false;
      this.dialog = false;
    },
    closeEmailPreview () {
      this.mediumSelected = '';
      this.reminder = {};
      this.subjectEmail = 'Reminder: Tell us how you feel';
      this.bodySMS = 'Hi You would have received a request from Amara to participate in a campaign, this campaign has been designed to gauge your satisfaction level at work. All you have to do is chat with Amara and she will take care of the rest. A gentle reminder to complete the chat by sparing 5 minutes, remember when we know how you feel, we can help you better.';
      this.bodyEmai = '<div>A big hello!</div><div><br></div><div>Hope you are doing great!</div><div><br></div><div><br></div><div>I am Amara, your virtual friend at work. Looks like you missed my last mail, so I am writing to you again.</div><div><br></div><div>I would like to chat with you to know your thoughts and feelings as it is essential&nbsp;to know more about you&nbsp;and your experiences at work. All you have to do is just spare five minutes and converse with me, I promise to make this very quick. Also, there are interesting methods to respond--choose an emoji, MCQs, and more. This will be fun and also help us to improve and enhance the workplace culture as per your wishes.&nbsp;</div>';

      this.previewDialogEmail = false;
    },
    closeSmsPreview () {
      this.mediumSelected = '';
      this.reminder = {};
      this.previewDialog = false;
    },
    preview (data) {
      const today = new Date();
      const date = today.getDate() + '-' + (today.getMonth() + 1) + '-' + today.getFullYear();
      const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
      const dateTime = date + ' ' + time;
      this.currentTime = dateTime;
      this.mediumSelected = data.channel;
      this.reminder = data;
      if (data.channel === 'sms') {
        this.previewDialog = true;
        this.bodySMS = data.body;
      }
      if (data.channel === 'email') {
        this.previewDialogEmail = true;
        this.bodyEmail = data.body;
      }
    },
    edit (data) {
      this.editView = true;
      this.reminderId = data.id;

      if (data.type) {
        this.mediumSelected = data.channel;
        this.reminder = data;
        if (data.channel === 'sms') {
          this.bodySMS = data.body;
        }
        if (data.channel === 'email') {
          this.bodyEmail = data.body;
          this.subjectEmail = data.subject;
        }
        this.dialog = true;
        this.previewData = false;
        if (data.type === 'automated') {
          this.reminder.heading = 'Automated reminder email';
        }
        if (data.type === 'onetime') {
          this.reminder.heading = 'One-off reminder email';
          this.date_time = data.trigger_date_time.split('T');
          this.reminder.date = this.date_time[0];
          this.date_time = this.date_time[1].split('+');
          this.reminder.time = this.date_time[0];
        }
      }
      if (this.testCampaigns) {
        setTimeout(() => {
          this.testEmail();
          this.mediumSelected = '';
        }, 100);
      }
    },
    deletes (data, index) {
      this.reminderData[index].slice(data);
    }
  },
  watch: {
    campaignDetails () {
    }
  },
  mounted () {
    this.infiniteHandler();
  },
  beforeMount () {
    this.getAdminUsers();
    // this.infiniteHandler();
    this.getReminder();
    if (this.$route.params && this.$route.params.stageId) {
      this.stageId = this.$route.params.stageId;
    }
    // console.log(this.$refs);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.emp-audit-wrap {
  .a-heading {
    margin: 12px;
    padding: 12px;
    font-size: 18px;
    font-weight: 600;
  }
  .list-wrap {
    height: 80vh;
    overflow-y: auto;
    .headers {
      display: grid;
      grid-template-columns: 3fr 2fr 1fr 1fr 1fr 1fr;
      grid-gap: 6px;
      margin: 12px 6px;
      font-size: 14px;
      padding: 12px;
      font-weight: 500;
      .uploaded-by {}
      .date-upload {
        align-self: center;
      }
      .success-count {
        align-self: center;
        justify-self: center;
      }
      .failure-count {
        align-self: center;
        justify-self: center;
      }
      .over-limit {
        align-self: center;
        justify-self: center;
      }
      .download {
        align-self: center;
        justify-self: center;
      }
    }
    .list-item {
      border-radius: 0.375rem;
      box-shadow: 8px 2px 12px #0000000b;
      display: grid;
      grid-template-columns: 3fr 2fr 1fr 1fr 1fr 1fr;
      grid-gap: 6px;
      margin: 12px 6px;
      padding: 12px;
      .uploaded-by {
        display: grid;
        grid-template-columns: 1fr 6fr;
        span {
          font-size: 16px !important;
        }
        .a-name {
          font-weight: 500;
        }
      }
      .date-upload {
        align-self: center;
      }
      .success-count {
        align-self: center;
        justify-self: center;
      }
      .failure-count {
        align-self: center;
        justify-self: center;
      }
      .over-limit {
        align-self: center;
        justify-self: center;
      }
      .download {
        align-self: center;
        justify-self: center;
        a {
          text-decoration: none;
        }
        &.disabledFile {
          pointer-events: none;
          opacity: 0.6;
        }
      }
    }
  }
}
</style>
<style lang="scss">

.theme--light {
  &.v-table {
    tbody {
      tr {
        &:not(:last-child) {
          border-bottom: 1px solid rgb(243, 241, 241)!important;
        }
      }
    }
  }
}
.reminderEditor {
.vp-editor {
 border:1px solid grey !important;
 border-radius: 8px;
 overflow:hidden;
 max-height:250px !important;
 .pell-content {
     max-height:200px;
     overflow-y:auto;
     overflow-x: hidden;
 }
}
}
.reminderadHoc {
    .difm-menu-split {
  height: 200px;
  float: left;
  margin-left: 63px;
  border-left: 1px solid #D0D2D3;
  margin-top: 15px;
  position: relative;
  left:15%;
}
.or-circle {
  box-sizing: border-box;
  height: 42px;
  width: 42px;
  line-height: 42px;
  border-radius: 50%;
  background-clip: padding-box;
  color: #6B787F;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid #D0D2D3;
  background-color: #fff;
  margin-top: 75px;
  position: absolute;
  left: -21px;
}

}
.mediumDialog {
  .v-input__slot {
    box-shadow: none !important;
    border:1px solid grey !important;
    margin:0;
  }
  div.error--text {
    .v-input__slot {
    box-shadow: none !important;
    border:1px solid red !important;
    margin:0;
  }
  .vp-editor {
 border:1px solid grey !important;
  }
  }
  .v-input__slot:focus {
    outline: 0 !important;
    border:1px solid rgb(2, 12, 155) !important;
  }
}
.followupList {
//   .v-list__tile {
//     height: 26px !important;
//   }
}
.previewDialogBox {
    background-image: url(../../../assets/logo/mobile.png);
    background-size: cover;
    border:none;
}
.previewDialogemail {
    background-image: url(../../../assets/logo/laptop.png);
    background-size: cover;
    border:none;
    background-repeat: round;
}
.v-dialog {
    box-shadow: none !important;
}
</style>
